
export const isWeex = typeof WXEnvironment !== "undefined" && WXEnvironment.platform !== "Web";
export const isReactNative = typeof navigator != "undefined" && navigator.product == "ReactNative";
